import { Component, ViewChild, ElementRef, ChangeDetectionStrategy} from '@angular/core';
import { IDoesFilterPassParams } from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';

@Component({ standalone: false,
  selector: 'dux-irb-ag-number-column-filter',
  templateUrl: './irb-ag-number-column-filter.component.html',
  styleUrls: ['./irb-ag-number-column-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class IrbAgNumberColumnFilterComponent implements IFilterAngularComp {
    private params: any;
    filter: any;
    filterTo: any;
    filterRaw: any;
    filterToRaw: any;
    isMinMaxValidationError: boolean;
    @ViewChild('filterValueInp') filterValueInp: ElementRef;
    @ViewChild('filterValueToInp') filterValueToInp: ElementRef;
    displaySymbol = '$';
    finMasonValidation: boolean;
    isVisible: boolean = false;
    doesFilterPassCallback: Function;
    private hidePopupFunc?: (params?: { hideReason?: string }) => void;

    agInit(params: any): void {
        this.params = params;

        if (this.params.displaySymbol) {
            this.displaySymbol = this.params.displaySymbol;
        }

        if (this.params.finMasonValidation) {
            this.finMasonValidation = this.params.finMasonValidation;
        }

        this.doesFilterPassCallback = (typeof this.params.doesFilterPass !== "undefined") ? this.params.doesFilterPass : null;
    }
    
    afterGuiAttached(params: any) {
        this.isVisible = true;
        if (params && params.hidePopup) {
            this.hidePopupFunc = params.hidePopup;
        }
    }

    afterGuiDetached() {
        this.isVisible = false;
    }

    isFilterActive(): boolean {
        return (this.filter !== null && this.filter !== undefined && this.filter !== '') || (this.filterTo !== null && this.filterTo !== undefined && this.filterTo !== '');
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        if(this.doesFilterPassCallback) {
            return this.doesFilterPassCallback(params, this.filterRaw, this.filterToRaw); 
        }
        
        return true;
    }
    getModelAsString(): any {
        return this.isFilterActive() ? (this.filter + '  -  ' + this.filterTo) : null;
    }

    getModel(): any {
        return this.isFilterActive() ? {
            // IREBAL-44003 - nativeElement gives JS error when refresh after edit multiple items
            // filter: this.filterValueInp.nativeElement.rawData,
            // filterTo: this.filterValueToInp.nativeElement.rawData,
            filter: this.filterRaw,
            filterTo: this.filterToRaw,
            filterType:'IrbAgNumberColumnFilterComponent'
        } : null;
    }

    setModel(model: any): void {
        this.filter = '';
        this.filterTo ='';
        if (model) {
            this.filter = this.displaySymbol + model.filter;
            this.filterRaw = model.filter;

            this.filterTo = this.displaySymbol + model.filterTo;
            this.filterToRaw = model.filterTo;
        }

        if (model === null) {
            this.clearAllValues();
        }
    }

    onApplyAction(): void {
        const minValue = this.filterValueInp.nativeElement.rawData;
        const maxValue = this.filterValueToInp.nativeElement.rawData;
        this.filterRaw = minValue;
        this.filterToRaw = maxValue;
        if(this.finMasonValidation === true){
            if (minValue && maxValue ) {
                this.isMinMaxValidationError = false;
            } else {
                this.isMinMaxValidationError = true;
            }
            if (minValue <= 0 || minValue >= 101  ) {
                this.isMinMaxValidationError = true;
            }
            if (maxValue < 1 || maxValue > 100) {
                this.isMinMaxValidationError = true;
            }
            if (minValue >  maxValue) {
                this.isMinMaxValidationError = true;
            }
            
        }else {
            if (minValue && maxValue === '') {
                this.isMinMaxValidationError = false;
            } else if (minValue === '' && maxValue) {
                this.isMinMaxValidationError = false;
            } else if (minValue >  maxValue) {
                this.isMinMaxValidationError = true;
            } else if (minValue === '' &&  maxValue === '') {
                this.isMinMaxValidationError = false;
            } else {
                this.isMinMaxValidationError = false;
            }
        }
        
        if ( this.isMinMaxValidationError === false) {
            this.params.filterChangedCallback();
            this.isVisible = false;
            if (this.hidePopupFunc) {
                this.hidePopupFunc();
            }
        }
    }
    onClearAction(): void {
       this.clearAllValues();
       this.params.filterChangedCallback();
       this.isVisible = false;
      if (this.hidePopupFunc) {
          this.hidePopupFunc();
      }
    }
    clearAllValues(): void {
        this.isMinMaxValidationError = false;
        this.filter = '';
        this.filterTo = '';
        this.filterRaw = '';
        this.filterToRaw = '';
        if (this.filterValueInp) {
            this.filterValueInp.nativeElement.rawData = '';
            this.filterValueToInp.nativeElement.rawData = '';
            this.filterValueInp.nativeElement.value = '';
            this.filterValueToInp.nativeElement.value = '';
        }
    }
}
